import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/member/newmember_pop_up_limited_time@2x.png'
import _imports_1 from '@/assets/image/icon/member/home_vip_pop_limited_time_ko.png'
import _imports_2 from '@/assets/image/icon/member/home_vip_pop_limited_time_en.png'


const _withScopeId = n => (_pushScopeId("data-v-f6bf3c56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "memberFloating"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "abs limitedTime"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "abs limitedTime"
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: "",
  class: "abs limitedTime"
}
const _hoisted_5 = { class: "newMemberInfo flex-ter mt_15" }
const _hoisted_6 = {
  key: 3,
  class: "newMemberInfo flex-ter"
}
const _hoisted_7 = { class: "numBack flex-cen-ter" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_10 = {
  key: 0,
  class: "symbol"
}
const _hoisted_11 = {
  key: 4,
  class: "newMemberInfo flex-ter"
}
const _hoisted_12 = { class: "numBack flex-cen-ter" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_15 = {
  key: 0,
  class: "symbol"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/member/new_member_home_pop_up_background@2x.png",
  alt: "",
  class: "abs backImg"
}, null, -1))
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/member/home_vip_floating@2x.png",
  alt: "",
  class: "abs backImg"
}, null, -1))

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { useRtfix, isJA, isKO, isEN, isJE } from '@/store'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { getActivePriceByStation, getCurrentMonetaryUnit } from '@/util/useYan'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const user = computed(() => store.getters.user)
const loginText = store.getters.isSub ? '查看会员' : '开通会员'
const onlyOpenSpecail = computed(() => store.getters.onlyOpenSpecail)
const visible = ref(user?.value?.membership?.templateLevel > 0)
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

const showFloating = ref(false)
const currentMonetaryUnit = getCurrentMonetaryUnit()

const memberClick = () => {
  confirmLoginWithNoCurShop(() => {
    if (user?.value?.membership?.templateLevel < 1) {
      router.push(useRtfix('VipLevel'))
    }
  })
}

const close = require('@/assets/image/icon/member/member-close-bold.png')

const memberClose = () => {
  showFloating.value = false
}

onMounted(() => {
  showFloating.value = true
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (!visible.value && showFloating.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(newMemberActivity)&&!_unref(onlyOpenSpecail))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : _createCommentVNode("", true),
              (_unref(isKO)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : _createCommentVNode("", true),
              (_unref(isEN)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("首次加入会员")), 1),
              (_unref(isJE)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref(t)("尊享首月")) + " ", 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_unref(isEN)() && _unref(newMemberActivity).hasSpecialTrialDiscount ? _unref(currentMonetaryUnit) : '') + " ", 1),
                      (_unref(newMemberActivity).hasSpecialTrialDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(newMemberActivity).specialPrice), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                            (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "％"))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createTextVNode(" " + _toDisplayString(!(_unref(isEN)() && _unref(newMemberActivity).hasSpecialTrialDiscount) ? (_unref(newMemberActivity).hasSpecialTrialDiscount? _unref(currentMonetaryUnit) : 'OFF') : ''), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(t)("尊享首月")) + " ", 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_unref(newMemberActivity).hasSpecialTrialDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(newMemberActivity).specialPrice) + " 원!", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                            (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "％"))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " OFF "))
                      : _createCommentVNode("", true)
                  ])),
              _createElementVNode("div", {
                class: "payForMember newMemberBtn cursor-pt mt_10",
                onClick: memberClick
              }, _toDisplayString(_unref(t)('立即入会')), 1),
              _hoisted_17
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('THE CKB会員なら')), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('もっと充実した中国仕入れサービスを利用可能！さらに、お得な会員限定特典満載！')), 1),
              _createElementVNode("div", {
                class: "payForMember flex-cen-ter cursor-pt",
                onClick: memberClick
              }, _toDisplayString(_unref(t)(_unref(loginText))), 1),
              _hoisted_20
            ], 64)),
        _createElementVNode("div", {
          class: "close flex-cen-ter cursor-pt",
          onClick: memberClose,
          style: {"opacity":"0"}
        }, [
          _createVNode(_component_el_image, { src: _unref(close) }, null, 8, ["src"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})